<template>
  <div>
    <el-form :inline="true" :model="queryFormModel" class="demo-form-inline" size="small">
      <el-form-item label="名称">
        <el-input v-model="queryFormModel.keyword" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="商户">
        <merchant-selector v-model="queryFormModel.merchantId"></merchant-selector>
      </el-form-item>
      <el-form-item label="启用状态">
        <el-select v-model="queryFormModel.enable" placeholder="请选择" clearable>
          <el-option key="1" label="启用" value="1"></el-option>
          <el-option key="0" label="禁用" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="queryList">查 询</el-button>
      </el-form-item>
    </el-form>

    <el-pagination
      style="margin-bottom: 5px; text-align: right;"
      background
      layout="prev, pager, next"
      :current-page.sync="page"
      :page-size.sync="rows"
      :total="tableTotal"
      @current-change="currentPageChanged">
    </el-pagination>

    <el-table ref="proxyTable" :data="tableData" :height="tableHeight" size="small" border style="width: 100%">
      <el-table-column prop="id" label="ID" width="200"></el-table-column>
      <el-table-column prop="merchantName" label="所属商户" width="200"></el-table-column>
      <el-table-column prop="name" label="名称"></el-table-column>
      <el-table-column prop="enable" label="启用状态" width="100">
        <template slot-scope="scope">
            <el-switch v-model="scope.row.enable" active-color="#13ce66" inactive-color="#ff4949" active-value="1" inactive-value="0" disabled></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="200">
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="showDetailDialog(scope.row)">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="代理详情" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <el-descriptions :column="1" border>
        <el-descriptions-item label="ID">{{ entity.id }}</el-descriptions-item>
        <el-descriptions-item label="所属商户">{{ entity.merchantName }}</el-descriptions-item>
        <el-descriptions-item label="名称">{{ entity.name }}</el-descriptions-item>
        <el-descriptions-item label="启用状态">{{ entity.enable === '1' ? '启用' : '禁用' }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ entity.createTime }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import httpClient from '../httpClient.js'
import MerchantSelector from './MerchantSelector.vue'
export default {
  name: "ProxyList",
  components: {
    MerchantSelector
  },
  data() {
    return {
      page: 1,
      rows: 20,
      tableTotal: 0,
      tableData: [],
      tableHeight: 400,
      queryFormModel: {},
      dialogVisible: false,
      entity: {}
    };
  },
  methods: {
    queryList() {
      let data = {
        page: this.page,
        rows: this.rows,
        params: this.queryFormModel
      }
      httpClient.post("/api/proxy/query", data).then((response) => {
        this.tableTotal = response.data.data.total
        this.tableData = response.data.data.list
      })
    },
    currentPageChanged() {
      this.queryList()
    },
    calcTableHeight() {
      this.$nextTick(() => {
        const tableEl = this.$refs.proxyTable && this.$refs.proxyTable.$el
        const top = tableEl ? tableEl.getBoundingClientRect().top : 200
        this.tableHeight = Math.max(300, window.innerHeight - top - 30)
      })
    },
    showDetailDialog(row) {
      httpClient.get(`/api/proxy/${row.id}`).then((response) => {
        this.entity = response.data.data
        this.dialogVisible = true
      })
    },
    handleClose() {
      this.dialogVisible = false
    }
  },
  mounted() {
    this.queryList()
    this.calcTableHeight()
    window.addEventListener('resize', this.calcTableHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calcTableHeight)
  },
};
</script>
